import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';
import { BUTTON_AS_TYPE, BUTTON_TYPE, SIZE, VARIANT } from '@motorway/mw-highway-code/enums';

import LocalTexts from './CookieBannerTexts.json';
import { COOKIE_POLICY_PATH } from './cookieConsent.constants';

import styles from './CookieBanner.module.scss';

const LocalT = new MDText(LocalTexts);

export type CookieBannerProps = {
  onAcceptAll: () => void;
  onEssentialOnly: () => void;
  onLearnMore?: () => void;
  takeover?: boolean;
};

export const CookieBanner = ({
  onAcceptAll,
  onEssentialOnly,
  onLearnMore,
  takeover = false,
}: CookieBannerProps) => {
  const buttonProps = takeover ? {
    fullWidth: true,
    size: SIZE.MEDIUM,
  } : {
    size: SIZE.SMALL,
  };

  return (
    <section
      aria-label={LocalT.translate('text') as string}
      className={styles.banner}
      data-testid="cookie-banner"
    >
      {takeover && <h2 className={styles.title} id="cookie-consent-title">{LocalT.translate('title')}</h2>}
      <div className={styles.actions}>
        <Button
          data-testid="cookie-banner-accept-all"
          label={LocalT.translate('acceptAll') as string}
          onClick={onAcceptAll}
          type={BUTTON_TYPE.BUTTON}
          variant={VARIANT.PRIMARY}
          {...buttonProps}
        />
        <Button
          data-testid="cookie-banner-essential-only"
          label={LocalT.translate('essentialOnly') as string}
          onClick={onEssentialOnly}
          type={BUTTON_TYPE.BUTTON}
          variant={VARIANT.SECONDARY}
          {...buttonProps}
        />
      </div>
      <div>
        <p className={styles.text}>{LocalT.translate('text')}{' '}</p>
        <Hyperlink
          underline
          as={BUTTON_AS_TYPE.ANCHOR}
          data-testid="cookie-banner-learn-more"
          href={COOKIE_POLICY_PATH}
          label={LocalT.translate('learnMore') as string}
          onClick={onLearnMore}
          rel='noopener noreferrer'
          size={takeover ? SIZE.MEDIUM : SIZE.SMALL}
          target='_blank' />
      </div>
    </section>
  );
};
